module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "propose"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Propose')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "to": "/propose_unapproved_list"
    }
  }, [(_vm.unapprovedCount > 0) ? _c('span', {
    staticClass: "badge pull-right margin-right",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.unapprovedCount) + " 件")]) : _vm._e(), _c('i', {
    staticClass: "margin-left fa fa-pencil-square-o"
  }), _c('p', {
    staticClass: "margin-right"
  }, [_vm._v(_vm._s(_vm.$t('Propose Unapproved List')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "to": "/propose_before_adopt_list"
    }
  }, [(_vm.approvedCount > 0) ? _c('span', {
    staticClass: "badge pull-right margin-right",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.approvedCount) + " 件")]) : _vm._e(), _c('i', {
    staticClass: "margin-left fa fa-trophy"
  }), _c('p', {
    staticClass: "margin-right"
  }, [_vm._v(_vm._s(_vm.$t('Propose Approved List')))])])], 1), _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/propose_result"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Propose Result')))])])], 1), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-4 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/propose_task_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Propose Title')))])])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abf1b550!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose.pug
// module id = 904
// module chunks = 1